import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 9.333a3 3 0 0 1 3 3V13l-.004.154a3 3 0 0 1-2.842 2.842L13 16H3l-.154-.004a3 3 0 0 1-2.842-2.842L0 13v-.667a3 3 0 0 1 3-3h10Zm-10 1a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-.667a2 2 0 0 0-2-2H3ZM13 0a3 3 0 0 1 3 3v.667l-.004.154a3 3 0 0 1-2.842 2.842L13 6.667H3l-.154-.004A3 3 0 0 1 .004 3.821L0 3.667V3a3 3 0 0 1 3-3h10ZM3 1a2 2 0 0 0-2 2v.667a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Z",
  fill: "#1F1F1F"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }